import { z } from 'zod';

/**
 * Schema for material type form data
 */
export const materialTypeSchema = z.object({
  ma_lvt: z.string().min(1, 'Mã loại vật tư không được để trống'),
  ten_lvt: z.string().min(1, 'Tên loại vật tư không được để trống'),
  ten_lvt2: z.string().nullable().optional(),
  status: z.string().optional()
});

/**
 * Type for material type form data
 */
export type MaterialTypeFormattedData = z.infer<typeof materialTypeSchema>;

export const initialFormValues: MaterialTypeFormattedData = {
  ma_lvt: '',
  ten_lvt: '',
  ten_lvt2: '',
  status: '1'
};
